// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Q4lCH","requiredAsterisk":"Info_requiredAsterisk__2NOWq"};